import { useEffect, useState } from "react";
import { endImpersonation, getImpersonation, type ImpersonationSession } from "@/lib/impersonation";

/**
 * Faixa fixa mostrada em TODAS as telas enquanto o admin está dentro da conta de alguém
 * ("entrar como", /admin). Deixa claro de quem é a conta e leva de volta ao /admin.
 */
export default function ImpersonationBanner() {
  const [session, setSession] = useState<ImpersonationSession | null>(() => getImpersonation());
  const [leaving, setLeaving] = useState(false);
  const [left, setLeft] = useState("");

  useEffect(() => {
    if (!session) return;
    const tick = () => {
      const ms = new Date(session.expires_at).getTime() - Date.now();
      if (!Number.isFinite(ms)) return setLeft("");
      if (ms <= 0) return setLeft("sessão encerrada");
      const m = Math.floor(ms / 60000);
      setLeft(m >= 60 ? `${Math.floor(m / 60)}h${String(m % 60).padStart(2, "0")} restantes` : `${m} min restantes`);
    };
    tick();
    const id = setInterval(tick, 30000);
    const onStorage = () => setSession(getImpersonation());
    window.addEventListener("storage", onStorage);
    return () => { clearInterval(id); window.removeEventListener("storage", onStorage); };
  }, [session]);

  if (!session) return null;
  const who = session.kind === "patient" ? "paciente" : "médico";

  return (
    <>
      {/* Reserva espaço para a faixa não cobrir o fim das páginas. */}
      <div aria-hidden className="h-14" />
      <div
        role="status"
        className="fixed bottom-0 inset-x-0 z-[9999] bg-amber-500 text-amber-950 shadow-[0_-4px_16px_rgba(0,0,0,0.15)]"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="max-w-5xl mx-auto px-3 sm:px-4 py-2 flex items-center gap-2 sm:gap-3">
          <i className="ri-spy-line text-xl shrink-0" />
          <p className="min-w-0 flex-1 text-[12px] sm:text-[13px] leading-tight">
            <strong className="font-black">Você está na conta de {session.target_name || who}</strong>
            <span className="hidden sm:inline"> ({who})</span>
            <span className="block text-[11px] opacity-80">Tudo o que fizer aqui fica registrado{left ? ` · ${left}` : ""}</span>
          </p>
          <button
            type="button"
            onClick={() => { setLeaving(true); void endImpersonation(); }}
            disabled={leaving}
            className="shrink-0 h-9 px-3 rounded-lg bg-slate-900 text-white text-[12px] font-bold hover:bg-slate-800 disabled:opacity-60 inline-flex items-center gap-1.5"
          >
            {leaving ? <i className="ri-loader-4-line animate-spin" /> : <i className="ri-arrow-go-back-line" />}
            Voltar ao admin
          </button>
        </div>
      </div>
    </>
  );
}
